import { GET_EMPLOYEESLIST } from "resources/actionTypes";

const initialEmployeesListState = {
  loading: false,
  error: null,
  employeesList: "",
};

export const getEmployeesList = (state = initialEmployeesListState, action) => {
  switch (action.type) {
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesList: action.employeesList,
      };
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_CLEARED:
      return {
        ...state,
        loading: false,
        employeesList: []
      };
      case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
    default:
      return state;
  }
};
